import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { faHome } from '@fortawesome/pro-regular-svg-icons/faHome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Breadcrumb, Skeleton } from 'antd';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { validate as isValidUUID } from 'uuid';

const idRoutes = [
  '/customers/manage-customers/',
  '/orders/manage-orders/',
  '/products/product-categories/',
  '/users/',
  '/locations/',
  '/products/',
  '/fleet/',
  '/opening-hours/',
];

const isDefinitiveIdRoute = (route: string) => {
  const idRoute = idRoutes.find((val) => route.startsWith(val));
  if (idRoute) {
    return isValidUUID(route.substring(idRoute.length));
  }
  return false;
};

interface BreadcrumbsProps {
  loading?: boolean;
}

export const Breadcrumbs = ({ loading }: BreadcrumbsProps) => {
  const crumbs = useBreadcrumbs();

  // for paths without pages
  const disabledPaths = useMemo(
    () => ['/orders', '/store-accounting', '/scheduling'],
    []
  );

  const breadcrumbLength = crumbs.length - 2;

  const breadcrumbItems = useMemo(
    () =>
      crumbs
        .slice(1)
        .filter(({ key }) => !isDefinitiveIdRoute(key))
        .map(({ breadcrumb, key }, index) => {
          return {
            title:
              breadcrumbLength === index || disabledPaths.includes(key) ? (
                breadcrumb
              ) : (
                <Link to={key}>{breadcrumb}</Link>
              ),
            key,
          };
        }),
    [breadcrumbLength, crumbs, disabledPaths]
  );

  const skeletonItems = Array.from(breadcrumbItems).map(({ key }) => ({
    key,
    title: <Skeleton.Button key={key} active size="small" />,
  }));

  return (
    <Breadcrumb
      items={
        loading
          ? skeletonItems
          : [
              {
                title: (
                  <Link to="/">
                    <FontAwesomeIcon icon={faHome} />
                  </Link>
                ),
                key: 'home',
              },
              ...breadcrumbItems,
            ]
      }
      style={{ textTransform: 'capitalize' }}
    />
  );
};
